import { SPACE, BACKSPACE, TRASH } from '../../../../../logic/search/search.constants';

export const DEFAULT_KEYBOARD = [
  ['a', 'ä'],
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  ['o', 'ö'],
  'p',
  'q',
  'r',
  ['s', 'ß'],
  't',
  ['u', 'ü'],
  'v',
  'w',
  'x',
  'y',
  'z',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  SPACE,
  BACKSPACE,
  TRASH,
];
